import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=f381821e&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=f381821e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f381821e",
  null
  
)

export default component.exports